import { render, staticRenderFns } from "./SuccessTickIconAnim.vue?vue&type=template&id=1ce864aa&scoped=true"
import script from "./SuccessTickIconAnim.vue?vue&type=script&lang=js"
export * from "./SuccessTickIconAnim.vue?vue&type=script&lang=js"
import style0 from "./SuccessTickIconAnim.vue?vue&type=style&index=0&id=1ce864aa&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce864aa",
  null
  
)

export default component.exports